/**
 * Pending map intent - plain in-memory hand-off from anywhere in the app to
 * the Agent Map page, matching this codebase's existing no-framework style
 * (see state/cartDrawer.ts for the same plain-module-state style applied to
 * a persistent singleton rather than a one-shot hand-off). The header
 * search box is the first consumer: a result clicked while on Dashboard/
 * Contacts/Profile needs to land on the map and jump straight to that
 * neighborhood/listing, not just navigate there blind.
 */

export type MapIntent =
  | { type: 'neighborhood'; id: string; name: string }
  | { type: 'listing'; lat: number; lng: number };

let pending: MapIntent | null = null;

export function setPendingMapIntent(intent: MapIntent): void {
  pending = intent;
}

/** Reads and clears the pending intent - one-shot, consumed at most once. */
export function consumePendingMapIntent(): MapIntent | null {
  const intent = pending;
  pending = null;
  return intent;
}
